import {
    SUB_AGENT_LIST_REQUEST,
    SUB_AGENT_LIST_SUCCESS,
    SUB_AGENT_LIST_FAIL,
    SUB_AGENT_LIST_RESET,
    SUB_AGENT_CREATE_REQUEST,
    SUB_AGENT_CREATE_SUCCESS,
    SUB_AGENT_CREATE_FAIL,
    SUB_AGENT_GET_REQUEST,
    SUB_AGENT_GET_SUCCESS,
    SUB_AGENT_GET_FAIL,
    SUB_AGENT_UPDATE_SUCCESS,
    SUB_AGENT_UPDATE_REQUEST,
    SUB_AGENT_UPDATE_FAIL,
    SUB_AGENT_DELETE_REQUEST,
    SUB_AGENT_DELETE_SUCCESS,
    SUB_AGENT_DELETE_FAIL,
    SUB_AGENT_CREATE_RESET,
    SUB_AGENT_GET_RESET
} from '../constants/subagentConstants'

import {
  SUB_AGENT_VERIFY_STATUS_REQUEST,
  SUB_AGENT_VERIFY_STATUS_SUCCESS,
  SUB_AGENT_VERIFY_STATUS_FAIL,
  SUB_AGENT_VERIFY_ACTION_REQUEST,
  SUB_AGENT_VERIFY_ACTION_SUCCESS,
  SUB_AGENT_VERIFY_ACTION_FAIL,
  SUB_AGENT_VERIFY_ACTION_RESET,
} from "../constants/subagentConstants";

// Get verification status reducer
export const getSubAgentVerifyStatusReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case SUB_AGENT_VERIFY_STATUS_REQUEST:
      return {
        loading: true,
      };

    case SUB_AGENT_VERIFY_STATUS_SUCCESS:
      return {
        loading: false,
        success: true,
        verifyStatus: action.payload,
      };

    case SUB_AGENT_VERIFY_STATUS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

// Verify action reducer
export const verifySubAgentStatusReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case SUB_AGENT_VERIFY_ACTION_REQUEST:
      return {
        loading: true,
      };

    case SUB_AGENT_VERIFY_ACTION_SUCCESS:
      return {
        loading: false,
        success: true,
        data: action.payload,
      };

    case SUB_AGENT_VERIFY_ACTION_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case SUB_AGENT_VERIFY_ACTION_RESET:
      return {};

    default:
      return state;
  }
};


export const subAgentListReducer = (state = { subAgents: [] }, action) => {
    switch (action.type) {
        case SUB_AGENT_LIST_REQUEST:
            return { loading: true };
        case SUB_AGENT_LIST_SUCCESS:
            return { loading: false, subAgents: action.payload }
        case SUB_AGENT_LIST_FAIL:
            return { loading: false, error: action.payload }
        case SUB_AGENT_LIST_RESET:
            return { loading: false, subAgents: [] }
        default:
            return state;
    }
}

export const subAgentCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case SUB_AGENT_CREATE_REQUEST:
            return { loading: true };
        case SUB_AGENT_CREATE_SUCCESS:
            return { loading: false, success: action.payload }
        case SUB_AGENT_CREATE_FAIL:
            return { loading: false, error: action.payload }
        case SUB_AGENT_CREATE_RESET:
            return { loading: false, success: '' }
        default:
            return state;
    }
}

export const subAgentDetailsReducer = (state = { subAgent: [] }, action) => {
    switch (action.type) {
        case SUB_AGENT_GET_REQUEST:
            return { loading: true, subAgent: [] };
        case SUB_AGENT_GET_SUCCESS:
            return { loading: false, subAgent: action.payload }
        case SUB_AGENT_GET_FAIL:
            return { loading: false, error: action.payload }
        case SUB_AGENT_GET_RESET:
            return { loading: false, subAgent: [] }
        default:
            return state;
    }
}

export const subAgentUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case SUB_AGENT_UPDATE_REQUEST:
            return { loading: true };
        case SUB_AGENT_UPDATE_SUCCESS:
            return { loading: false, success: action.payload }
        case SUB_AGENT_UPDATE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

export const subAgentDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case SUB_AGENT_DELETE_REQUEST:
            return { loading: true };
        case SUB_AGENT_DELETE_SUCCESS:
            return { loading: false, success: action.payload }
        case SUB_AGENT_DELETE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}



